// Firmas pendientes del supervisor (autorización en línea): contador en la barra que se refresca solo
// cada 10 s y suena un bip cuando llega una solicitud nueva. Un clic abre «Pendientes de firma».
// Incluye lo que la caja pidió emitir sin pago (0122, Rodrigo 2026-10-27).
import { useEffect, useRef } from 'react';
import { useNotas, useSolicitudesCambio } from '../api/consultas';
import { useSesion } from '../sesion/SesionContexto';
import { useFirmasSinPago } from '../ventas/SinPagoMeson';

function bip() {
  try {
    const Ctx =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.frequency.value = 880;
    g.gain.value = 0.08;
    o.connect(g).connect(ctx.destination);
    o.start();
    o.stop(ctx.currentTime + 0.18);
    o.onended = () => void ctx.close();
  } catch {
    /* sin audio (navegador sin permiso de sonido): el contador basta */
  }
}

export function FirmasPendientes({
  empresaId,
  alAbrir,
}: {
  empresaId: string;
  alAbrir: () => void;
}) {
  const q = useNotas(empresaId, { estado: 'EN_APROBACION', pagina: 1 }, true, 10_000);
  // Los cambios de ficha pedidos en línea también se firman aquí (Rodrigo, 2026-10-24).
  const { puede } = useSesion();
  const fichas = useSolicitudesCambio(
    empresaId,
    { estado: 'PENDIENTE' },
    puede('entidades.ficha.aprobar_cambio'),
  );
  // Emitir sin pago desde la caja (0122): cuentan las que quien mira puede firmar.
  const sinPago = useFirmasSinPago(
    empresaId,
    { estado: 'PENDIENTE' },
    puede('ventas.documento.sin_pago'),
  );
  const total =
    (q.data?.items.length ?? 0) +
    (fichas.data?.length ?? 0) +
    (sinPago.data?.items.filter((x) => x.puedeFirmar).length ?? 0);
  const previo = useRef<number | null>(null);
  useEffect(() => {
    if (!q.isSuccess) return;
    if (previo.current !== null && total > previo.current) bip();
    previo.current = total;
  }, [q.isSuccess, total]);
  return (
    <button
      type="button"
      className={`boton-barra firmas-pendientes${total ? ' con-pendientes' : ''}`}
      onClick={alAbrir}
      title="Notas y cambios de ficha que esperan tu firma (se actualiza sola)"
      aria-label={`Firmas pendientes: ${total}`}
      data-firmas-pendientes={total}
    >
      Firmas <b>{total}</b>
    </button>
  );
}
